import { useRef, useCallback, type ChangeEvent } from 'react';

export const useDebouncedSearch = (
  callback: (query: string) => void,
  delay: number
): ((event: ChangeEvent<HTMLInputElement>) => void) => {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  return useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        callback(value);
      }, delay);
    },
    [callback, delay]
  );
};
